import { render } from "./CategoryDetailsOverview.vue?vue&type=template&id=b19fc706&scoped=true"
import script from "./CategoryDetailsOverview.vue?vue&type=script&lang=js"
export * from "./CategoryDetailsOverview.vue?vue&type=script&lang=js"

import "./CategoryDetailsOverview.vue?vue&type=style&index=0&id=b19fc706&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19fc706"],['__file',"src/components/CategoryDetailsOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b19fc706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b19fc706', __exports__)) {
    console.log('reload')
    api.reload('b19fc706', __exports__)
  }
  
  module.hot.accept("./CategoryDetailsOverview.vue?vue&type=template&id=b19fc706&scoped=true", () => {
    console.log('re-render')
    api.rerender('b19fc706', render)
  })

}


export default __exports__